import { render, staticRenderFns } from "./ActivationBriefOrdersListRouterView.vue?vue&type=template&id=443ce808&"
import script from "./ActivationBriefOrdersListRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefOrdersListRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports